/**
 * isObject checks whether the input is an object.
 * @param object the input to check
 * @returns whether the input is an object
 */
export const isObject = (object) => object === Object(object) && !Array.isArray(object) && typeof object !== "function";
